import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, InputGroup, Form, Button } from "react-bootstrap";

import "../../cssFiles/CashCount.css";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import {
  getFullNameUser,
  getRestoLogin,
  getRole,
  getToken,
  numberWithCommas,
  refreshPage,
  removeUserSession,
  toastStyle,
} from "../../Helpers/Utils/Common";
import toast from "react-hot-toast";
import CashCountPrint from "../../Components/Print/CashCountPrint";
import { printBase64 } from "../../Helpers/apiCalls/paymentAPI";
import html2canvas from "html2canvas";
import { UsePostRequest } from "../../Helpers/hooks/UsePostApiCall";
import moment from "moment";

function CashCount() {
  const navigate = useNavigate();
  const state = useLocation();
  const [inactive, setInactive] = useState(true);
  const [isClicked, setIsClicked] = useState(false);

  // REMITTED
  const [billsRemitted, setBillsRemitted] = useState([
    {
      bill: "1000",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "500",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "200",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "100",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "50",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "20",
      qty: 0,
      total: 0.0,
    },
  ]);
  const [coinsRemitted, setCoinsRemitted] = useState([
    {
      coin: "10",
      qty: 0,
      total: 0.0,
    },
    {
      coin: "5",
      qty: 0,
      total: 0.0,
    },
    {
      coin: "1",
      qty: 0,
      total: 0.0,
    },
  ]);
  const [centsRemitted, setCentsRemitted] = useState([
    {
      cent: "25",
      qty: 0,
      total: 0.0,
    },
    {
      cent: "10",
      qty: 0,
      total: 0.0,
    },
    {
      cent: "5",
      qty: 0,
      total: 0.0,
    },
    {
      cent: "1",
      qty: 0,
      total: 0.0,
    },
  ]);
  const [totalCoinRemitted, setTotalCoinRemitted] = useState(0);
  const [totalRemit, setTotalRemit] = useState(0);

  // DRAWER
  const [billsDrawer, setBillsDrawer] = useState([
    {
      bill: "1000",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "500",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "200",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "100",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "50",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "20",
      qty: 0,
      total: 0.0,
    },
  ]);

  async function createCashCount() {
    const tempBillsRemitted = {};
    billsRemitted.forEach((bill) => {
      tempBillsRemitted[`bill_${bill.bill}`] = bill.qty;
    });
    const tempCoinsRemitted = {};
    coinsRemitted.forEach((coin) => {
      tempCoinsRemitted[`coin_${coin.coin}`] = coin.qty;
    });
    const tempCentsRemitted = {};
    centsRemitted.forEach((cent) => {
      tempCentsRemitted[`cent_${cent.cent}`] = cent.qty;
    });
    const tempBillsDrawer = {};
    billsDrawer.forEach((bill) => {
      tempBillsDrawer[`drawer_bill_${bill.bill}`] = bill.qty;
    });

    const payload = {
      token: getToken(),
      ...tempBillsRemitted,
      ...tempCoinsRemitted,
      ...tempCentsRemitted,
      ...tempBillsDrawer,
      coins_in_drawer: 0,
      coins_remitted: totalCoinRemitted,
      count_date: moment().format("MM/DD/YYYY"),
    };
    const response = await UsePostRequest("cash_counts/create", payload, false, getRestoLogin());
    if (response.data) {
      toast.success("Successfully added cash count", {style: toastStyle()});
      setTimeout(() => {
        removeUserSession();
        navigate("/");
        refreshPage();
      }, 500)
    } else {
      setIsClicked(false)
      toast.error("Error in adding cash count", {style: toastStyle()})
    }
  }

  const exceptThisSymbols = ["e", "E", "+", "-", "."];

  const handleBillsQtyChange = (e, index) => {
    const { name, value } = e.target;
    const tempBill = [...billsRemitted];
    tempBill[index][name] = value;
    tempBill[index]["total"] = value * parseInt(tempBill[index].bill);
    setBillsRemitted(tempBill);
  };

  const handleCoinsQtyChange = (e, index) => {
    const { name, value } = e.target;
    const tempData = [...coinsRemitted];
    tempData[index][name] = value;
    tempData[index]["total"] = value * parseInt(tempData[index].coin);
    setCoinsRemitted(tempData);
  };

  const handleCentsQtyChange = (e, index) => {
    const { name, value } = e.target;
    const tempData = [...centsRemitted];
    tempData[index][name] = value;
    tempData[index]["total"] = (value * parseInt(tempData[index].cent)) / 100;
    setCentsRemitted(tempData);
  };

  const divId = useRef(null);

  const handlePrint = () => {
    if (divId.current) {
      setIsClicked(true)
      const element = divId.current;

      // Apply custom CSS for the desired paper size (80mm x 297mm)
      element.style.width = "30%";
      element.style.height = "auto";

      html2canvas(element, { scale: 1 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        //  const newWindow = window.open();
        // if (newWindow) {
        //   // Write the image to the new window
        //   newWindow.document.write(`<img src="${imgData}" alt="Captured Image"/>`);
        //   newWindow.document.close();
        // }
        printBase64Data(imgData);
      });
    }
  };

  async function printBase64Data(image) {
    const response = await printBase64(
      window.printer_name, 
      image, 
      "0",
      getRestoLogin(),
      "Cash Count"
    );
    if (response.data) {
      createCashCount()
    } else {
      setIsClicked(false)
      toast.error("Error in printing")
    }
  }

  React.useEffect(() => {
    const tempTotalBill = billsRemitted.reduce(
      (a, b) => a + parseFloat(b.total),
      0
    );
    const tempTotalCoins = coinsRemitted.reduce(
      (a, b) => a + parseFloat(b.total),
      0
    );
    const tempTotalCents = centsRemitted.reduce(
      (a, b) => a + parseFloat(b.total),
      0
    );
    setTotalCoinRemitted(tempTotalCoins + tempTotalCents);
    setTotalRemit(tempTotalBill + tempTotalCoins + tempTotalCents);
  }, [billsRemitted, coinsRemitted, centsRemitted]);

  return (
    <div>
      {state.state.name !== "cashier" && (
        <NavbarAdmin
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"Cash Count"} //Dashboard navbar index
          page={"Cash Count"}
        />
      )}
      <div
        className={`container bold-font ${
          getRole() === "2" ? "cashier" : inactive ? "mt-3" : "active"
        }`}
        id="forPrinting"
      >
        <Row className="p-0">
          <h1 className="page-title-menu">ADD CASH COUNT </h1>
        </Row>
        <hr />
        <Row className="pt-2 b-shadow count-border-cc rounded mb-0">
          <Col className="left-div cashCount-width">
            <Row className="">
              <h5>
                <strong>Cash Remitted</strong>
              </h5>
            </Row>
            {billsRemitted.map((data, index) => {
              return (
                <Row className="cash-bottom">
                  <Col xs={2}>
                    <label>{data.bill}</label>
                  </Col>
                  <Col>
                    <label>x</label>
                  </Col>
                  <Col xs={3}>
                    <InputGroup>
                      <Form.Control
                        name="qty"
                        type="number"
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing"
                        value={data.qty}
                        onChange={(e) =>
                          handleBillsQtyChange(e, index, "count")
                        }
                        onKeyDown={(e) =>
                          exceptThisSymbols.includes(e.key) &&
                          e.preventDefault()
                        }
                        onWheel={(e) => e.target.blur()}
                      />
                    </InputGroup>
                  </Col>
                  <Col>
                    <label>=</label>
                  </Col>
                  <Col className="align-right" xs={3}>
                    <label>₱ {numberWithCommas(data.total)}</label>
                  </Col>
                </Row>
              );
            })}
 
            {coinsRemitted.map((data, index) => {
              return (
                <Row className="cash-bottom">
                  <Col xs={2}>
                    <label>{data.coin} coin</label>
                  </Col>
                  <Col>
                    <label>x</label>
                  </Col>
                  <Col xs={3}>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        name="qty"
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing"
                        value={data.qty}
                        onChange={(e) =>
                          handleCoinsQtyChange(e, index, "count")
                        }
                        onKeyDown={(e) =>
                          exceptThisSymbols.includes(e.key) &&
                          e.preventDefault()
                        }
                        onWheel={(e) => e.target.blur()}
                      />
                    </InputGroup>
                  </Col>
                  <Col>
                    <label>=</label>
                  </Col>
                  <Col className="align-right" xs={3}>
                    <label>₱ {numberWithCommas(data.total)}</label>
                  </Col>
                </Row>
              );
            })}

            {centsRemitted.map((data, index) => {
              return (
                <Row className="cash-bottom">
                  <Col xs={2}>
                    <label>{data.cent} cent</label>
                  </Col>
                  <Col>
                    <label>x</label>
                  </Col>
                  <Col xs={3}>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        name="qty"
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing"
                        value={data.qty}
                        onChange={(e) => handleCentsQtyChange(e, index)}
                        onKeyDown={(e) =>
                          exceptThisSymbols.includes(e.key) &&
                          e.preventDefault()
                        }
                        onWheel={(e) => e.target.blur()}
                      />
                    </InputGroup>
                  </Col>
                  <Col>
                    <label>=</label>
                  </Col>
                  <Col className="align-right" xs={3}>
                    <label>₱ {numberWithCommas(data.total)}</label>
                  </Col>
                </Row>
              );
            })}

            <hr className="p-0 m-0" />
            <Row className="d-flex row justify-content-between mt-2 py-1">
              <Col>
                <h5>TOTAL</h5>
              </Col>
              <Col className="align-right">
                <h5>
                  <strong>₱ {numberWithCommas(totalRemit)}</strong>
                </h5>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col sm={6}></Col>
          <Col sm={3} className="d-flex justify-content-end">
            <Button
              size={"md"}
              variant="info"
              className="button-secondary w-100"
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          </Col>
          <Col sm={3} className="d-flex justify-content-end">
            <Button
              onClick={handlePrint}
              size={"md"}
              variant="success"
              className="button-primary w-100"
              disabled={totalRemit <= 0 || isClicked}
            >
              Save
            </Button>
          </Col>
        </Row>

          <div className="hide-from-screen" ref={divId}>
              <CashCountPrint
                billsRemitted={billsRemitted}
                totalRemit={totalRemit}
                coinsRemitted={coinsRemitted}
                centsRemitted={centsRemitted}
                cashier={getFullNameUser()}
              />
          </div>
      </div>
    </div>
  );
}

export default CashCount;
